import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-85b27568"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "¡Bienvenido a nuestra sección de Ejercicios!", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Accede a las secciones de ejercicios correspondientes a los cursos adquiridos y practica con ejercicios diseñados específicamente para reforzar los conocimientos impartidos en cada curso. ", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = { class: "table-container" }
const _hoisted_7 = { class: "modern-table" }
const _hoisted_8 = { key: 0 }

import DefaultLayout from '@/layouts/DefaultLayout.vue';
import ExercisesService from '@/services/ExerciseService';
import { onMounted,ref,Ref } from 'vue';
import main from '@/data/main.js';
import useWindowWidth from '@/composables/useWindowWidth';
import ActivityInterface from '@/interfaces/ActivityInterface';


export default /*#__PURE__*/_defineComponent({
  __name: 'ActivityView',
  setup(__props) {

const { windowWidth } = useWindowWidth()
const tableSmall = ref(850);

const loading:Ref<boolean> = ref(false)
const service = new ExercisesService()
const activities:Ref<ActivityInterface[]> = ref([])

onMounted(async()=>{
    loading.value = true
  activities.value = await service.GetExercises()
  loading.value = false
})
 



return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createBlock(DefaultLayout, null, {
    default: _withCtx(() => [
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_v_icon, {
              name: "ri-loader-2-fill",
              animation: "spin",
              class: "icon"
            })
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _hoisted_4,
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("table", _hoisted_7, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                (_unref(windowWidth) > tableSmall.value)
                  ? (_openBlock(), _createElementBlock("th", _hoisted_8, _toDisplayString(_unref(main).TH_1_ACTIVITY_COURSE_VIEW), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("th", null, _toDisplayString(_unref(main).TH_2_ACTIVITY_COURSE_VIEW), 1),
                _createElementVNode("th", null, _toDisplayString(_unref(main).TH_3_ACTIVITY_COURSE_VIEW), 1),
                _createElementVNode("th", null, _toDisplayString(_unref(main).TH_4_ACTIVITY_COURSE_VIEW), 1)
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activities.value, (elm) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: elm?.id
                }, [
                  _createElementVNode("td", null, _toDisplayString(elm?.language), 1),
                  _createElementVNode("td", null, _toDisplayString(elm?.number_of_execercises), 1),
                  _createElementVNode("td", null, _toDisplayString(elm?.date), 1),
                  _createElementVNode("td", null, [
                    _createVNode(_component_RouterLink, {
                      to: { name: 'viewActivity', params:{id : elm?.id} }
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, {
                          name: "md-fileopen-round",
                          class: "ver",
                          fill: _unref(main).THIRD_COLOR,
                          scale: "2"
                        }, null, 8, ["fill"])
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ])
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})